export default "__VITE_ASSET__99d008d7__"